module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/1-5mill-active-044104c0306048fdd08165d5996688e4.png";